export function footerFunc() {
  shiftFooterOnType1();
}

/**
 * .l-page--type1 のとき、フッターを上方向にずらして
 * .l-page__bg-bottom との余白を一定に保つ。
 *
 * 1920px 幅を基準に margin-top: -569px とし、
 * 1920px 以上のときのみレイアウト幅に比例して可変させる。
 */
function shiftFooterOnType1() {
  const page = document.querySelector('.l-page--type1');
  const footer = document.querySelector('.l-footer');

  if (!page || !footer) return;

  const BASE_WIDTH = 1920;
  const BASE_MARGIN = 569;

  /**
   * 拡縮前のレイアウト幅を返す。
   * ・1280px以上 : ビューポート幅
   * ・1025〜1279px: PCデザイン基準 1280px（zoom で縮小される帯）
   * ・1024px以下 : SPデザイン基準幅（viewport 768 等）
   */
  function getLayoutWidth() {
    const w = document.documentElement.clientWidth || window.innerWidth;
    const isSpDesign = window.matchMedia('(max-width: 1024px)').matches;

    if (isSpDesign) {
      return w;
    }
    if (w >= 1280) {
      return w;
    }
    return 1280;
  }

  const update = () => {
    const layoutW = getLayoutWidth();
    const margin =
      layoutW >= BASE_WIDTH
        ? BASE_MARGIN * (layoutW / BASE_WIDTH)
        : BASE_MARGIN;
    footer.style.marginTop = `-${margin}px`;
  };

  update();

  let resizeTimer = null;
  window.addEventListener('resize', () => {
    if (resizeTimer) cancelAnimationFrame(resizeTimer);
    resizeTimer = requestAnimationFrame(update);
  });

  window.addEventListener('load', update, false);
}
